module.exports = __webpack_public_path__ + "1-05.png?e6fad0fed0363c34eb7de959d1506cb8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-05.png
// module id = 82
// module chunks = 0